import { useUI } from '../store/ui'

/**
 * The single "blur 18+" switch. Every surface (accounts panel, settings
 * panel, settings page) renders this instead of hand-rolling its own
 * control, so copy + behaviour stay in lockstep. All variants drive the
 * same useUI.blurAdult flag.
 *
 * - `compact` (default): the dark ops-panel row with an on/off pill.
 * - `full`: the settings-page checkbox with the long explanation.
 */
export function BlurAdultToggle({
  variant = 'compact',
}: {
  variant?: 'compact' | 'full'
}) {
  const blurAdult = useUI((s) => s.blurAdult)
  const setBlurAdult = useUI((s) => s.setBlurAdult)
  const toggleBlurAdult = useUI((s) => s.toggleBlurAdult)

  if (variant === 'full') {
    return (
      <label className="mt-2 flex items-start gap-2 text-xs">
        <input
          type="checkbox"
          checked={blurAdult}
          onChange={(e) => setBlurAdult(e.target.checked)}
          className="mt-0.5"
        />
        <span>
          <strong className="text-white">blur adult-labelled tiles</strong>
          <span className="block text-[11px] text-ink-300">
            When on, gallery tiles + the lightbox blur posts whose AppView
            labels mark them adult (porn / sexual / nudity / graphic-media
            / nsfw etc) until you click them. Default <strong>off</strong> —
            this is your local cache, not a public feed reader.
          </span>
        </span>
      </label>
    )
  }

  return (
    <div className="flex items-center gap-2 bg-[#070d1c] px-3 py-2">
      <div className="min-w-0 flex-1">
        <div className="text-xs text-ink-100">blur 18+ tiles</div>
        <div className="text-[9px] text-ink-400">adult media blurred until hovered</div>
      </div>
      <button
        type="button"
        onClick={toggleBlurAdult}
        className={`px-2 py-0.5 text-[10px] font-bold ${
          blurAdult
            ? 'border border-emerald-400/40 bg-emerald-500/15 text-emerald-100'
            : 'border border-white/10 bg-white/5 text-ink-300'
        }`}
      >
        {blurAdult ? 'on' : 'off'}
      </button>
    </div>
  )
}
